import { Context } from "./singleton";

export class MobileMenu {
  mobile_nav() {
    Context.getInstance().menu_is_open = !Context.getInstance().menu_is_open;
    console.log(Context.getInstance().menu_is_open);
    const element = document.getElementById("header-menu");
    // const element = document.getElementById("menu");
    // const blur = document.getElementById("menu_blur");
    if (element) {
      if (Context.getInstance().menu_is_open) {
        element.classList.remove("hidden");
        // if (blur) {
        //   blur.classList.remove("hidden");
        // }
      } else {
        element.classList.add("hidden");
        // if (blur) {
        //   blur.classList.add("hidden");
        // }
      }
    }
  }
}